import { Link } from 'react-router-dom';
import { activities } from '@/mocks/homeData';

const activityImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20atmosphere%20with%20football%20elements%20and%20celebration%20vibes%2C%20warm%20golden%20and%20green%20lighting%20accents%2C%20artistic%20sports%20photography%20style%20with%20energy%20and%20excitement%2C%20professional%20event%20promotion%20visual%20with%20rich%20dark%20backgrounds%20and%20vibrant%20highlights&width=800&height=500&seq=kaiyun-activity-new-user&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Champions%20League%20final%20celebration%20scene%20with%20trophy%20and%20confetti%2C%20dramatic%20stadium%20lighting%20with%20golden%20and%20green%20accents%2C%20artistic%20sports%20event%20promotion%20visual%20with%20energetic%20atmosphere%2C%20professional%20football%20photography%20style%20with%20vibrant%20highlights&width=800&height=500&seq=kaiyun-activity-ucl&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Daily%20check%20in%20reward%20concept%20with%20football%20merchandise%20and%20golden%20coins%2C%20warm%20ambient%20lighting%20with%20green%20and%20gold%20tones%2C%20artistic%20product%20photography%20style%20with%20luxurious%20feel%2C%20professional%20sports%20lifestyle%20visual&width=800&height=500&seq=kaiyun-activity-checkin&orientation=landscape',
};

export default function ActivitiesSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 md:mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
              最新活动
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              精彩活动不容错过
            </h2>
          </div>
          <Link
            to="/category/events"
            className="mt-3 sm:mt-0 flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看更多活动
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {activities.map((activity) => (
            <Link
              key={activity.id}
              to={activity.link}
              className="group rounded-2xl overflow-hidden bg-background-50 hover:shadow-md transition-all duration-300"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={activityImages[activity.id]}
                  alt={activity.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                    {activity.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {activity.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                  {activity.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}